(() => {
  const maskCep = (value) => {
    const digits = value.replace(/\D/g, "").slice(0, 8);
    if (digits.length <= 5) return digits;
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  };

  const getVariantId = (root) => {
    const form = root.closest("form") || document.querySelector('form[action="/cart/add"]');
    const input = form?.querySelector('input[name="id"]');
    return input?.value || root.getAttribute("data-variant-id");
  };

  const setLoading = (root, loading) => {
    const loadingEl = root.querySelector(".loading");
    if (!loadingEl) return;
    loadingEl.style.display = loading ? "block" : "none";
  };

  const setResults = (root, html) => {
    const container = root.querySelector(".product-shipping .results");
    const resultWrap = root.querySelector(".result-container");
    const inputPart = root.querySelector(".product-shipping .input-part");
    if (container) container.innerHTML = html;
    if (resultWrap) resultWrap.style.display = "block";
    if (inputPart) inputPart.style.display = "none";
  };

  const hideResults = (root) => {
    const resultWrap = root.querySelector(".result-container");
    if (resultWrap) resultWrap.style.display = "none";
  };

  const fetchJson = async (url, options) => {
    const res = await fetch(url, options);
    if (!res.ok) throw new Error("Request failed");
    return res.json();
  };

  const calculateShipping = async (root) => {
    const input = root.querySelector("#billing_cep");
    if (!input) return;
    const postalCode = input.value.trim();
    if (!postalCode) {
      hideResults(root);
      return;
    }

    const variantId = getVariantId(root);
    if (!variantId) {
      setResults(root, "<p>Selecione uma variante para calcular o frete.</p>");
      return;
    }

    setLoading(root, true);
    hideResults(root);
    root.classList.add("waiting");

    try {
      const cepData = await fetchJson(`https://viacep.com.br/ws/${postalCode}/json/`);
      if (cepData.erro) {
        setResults(root, "<p>CEP inválido.</p>");
        return;
      }

      const province = cepData.uf;
      await fetchJson("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      const rates = await fetchJson(
        `/cart/shipping_rates.json?shipping_address[zip]=${encodeURIComponent(
          postalCode
        )}&shipping_address[country]=BR&shipping_address[province]=${encodeURIComponent(province)}`
      );

      let html = "";
      if (Array.isArray(rates.shipping_rates) && rates.shipping_rates.length > 0) {
        html = rates.shipping_rates
          .map((rate) => {
            const days = Array.isArray(rate.delivery_days) ? rate.delivery_days[0] : "";
            return `
              <div class="shipping">
                <div class="shipping-info">
                  <span class="rate-name">${rate.name}:</span>
                  <span class="rate-days">${days} dias úteis</span>
                </div>
                R$ ${rate.price}
              </div>
            `;
          })
          .join("");
      } else {
        html = "<p>Não foi possível calcular o frete.</p>";
      }

      setResults(root, html);
    } catch {
      setResults(root, "<p>Não foi possível calcular o frete.</p>");
    } finally {
      setLoading(root, false);
      root.classList.remove("waiting");
      try {
        await fetchJson("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 0 }),
        });
      } catch {
        // ignore cleanup errors
      }
    }
  };

  const init = (root) => {
    const input = root.querySelector("#billing_cep");
    const button = root.querySelector("#submit-main-shipping");
    const toggle = root.querySelector(".cep-toggle");
    if (!input || !button) return;

    input.addEventListener("input", () => {
      input.value = maskCep(input.value);
    });

    button.addEventListener("click", (e) => {
      e.preventDefault();
      calculateShipping(root);
    });

    if (toggle) {
      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        hideResults(root);
        const inputPart = root.querySelector(".product-shipping .input-part");
        if (inputPart) inputPart.style.display = "flex";
      });
    }
  };

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-product-shipping]").forEach((root) => init(root));
  });
})();
